// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
var ConversationPageSelectedConversationDisplayer = require("./ConversationPageSelectedConversationDisplayer.bs.js");
var ConversationPageExistingConversationQuery_graphql = require("../../../__generated__/ConversationPageExistingConversationQuery_graphql.bs.js");
var ConversationPageExistingConversation_conversation_graphql = require("../../../__generated__/ConversationPageExistingConversation_conversation_graphql.bs.js");

var convertVariables = ConversationPageExistingConversationQuery_graphql.Internal.convertVariables;

var convertResponse = ConversationPageExistingConversationQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = ConversationPageExistingConversationQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, ConversationPageExistingConversationQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, ConversationPageExistingConversationQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ConversationPageExistingConversationQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ConversationPageExistingConversationQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(ConversationPageExistingConversationQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(ConversationPageExistingConversationQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

var convertFragment = ConversationPageExistingConversation_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageExistingConversation_conversation_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageExistingConversation_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageExistingConversation_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageExistingConversation_conversation_graphql.node, convertFragment, fRef);
}

var ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageExistingConversation$RecordPageView(props) {
  var conversation = use$1(props.conversation);
  var match = conversation.conversationContext;
  if (match === undefined) {
    return null;
  }
  if (match.__typename !== "AvailableConversationContext") {
    return null;
  }
  var conversationContext = match.context;
  if (conversationContext !== undefined) {
    return JsxRuntime.jsx(ConversationsPageRelayCommon.RecordPageView.ConversationViewByConversationContext.make, {
                conversationContext: Caml_option.some(conversationContext.fragmentRefs),
                activeConversationId: {
                  TAG: "Existing",
                  _0: props.selectedConversationId
                }
              });
  } else {
    return null;
  }
}

var RecordPageView = {
  ConversationFragment: ConversationFragment,
  make: ConversationPageExistingConversation$RecordPageView
};

function ConversationPageExistingConversation(props) {
  var selectedConversationId = props.selectedConversationId;
  var data = use({
        id: selectedConversationId
      }, undefined, undefined, undefined);
  var match = data.conversationById;
  var tmp;
  if (match !== undefined) {
    switch (match.__typename) {
      case "ConversationV5" :
          tmp = JsxRuntime.jsx(React.Suspense, {
                children: Caml_option.some(JsxRuntime.jsx(ConversationPageExistingConversation$RecordPageView, {
                          conversation: match.fragmentRefs,
                          selectedConversationId: selectedConversationId
                        })),
                fallback: Caml_option.some(null)
              });
          break;
      case "NotAuthorizedError" :
      case "__unselected" :
          tmp = null;
          break;
      
    }
  } else {
    tmp = null;
  }
  var match$1 = data.conversationById;
  var tmp$1;
  if (match$1 !== undefined) {
    switch (match$1.__typename) {
      case "ConversationV5" :
          tmp$1 = JsxRuntime.jsx(React.Suspense, {
                children: Caml_option.some(JsxRuntime.jsx(ConversationPageSelectedConversationDisplayer.make, {
                          conversation: match$1.fragmentRefs
                        })),
                fallback: Caml_option.some(JsxRuntime.jsx(Loader.make, {}))
              });
          break;
      case "NotAuthorizedError" :
          tmp$1 = "You're not authorized to view this conversation";
          break;
      case "__unselected" :
          tmp$1 = null;
          break;
      
    }
  } else {
    tmp$1 = "Conversation not found.";
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                tmp,
                tmp$1
              ]
            });
}

var make = ConversationPageExistingConversation;

exports.Query = Query;
exports.RecordPageView = RecordPageView;
exports.make = make;
/* use Not a pure module */
